import { render, staticRenderFns } from "./trackings-table.vue?vue&type=template&id=6dc11344"
import script from "./trackings-table.vue?vue&type=script&lang=js"
export * from "./trackings-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports